import styled from "styled-components";
// import { Container } from "../navbar/Nav.styles"
import Image from "../../assets/section2.svg";
import { CgFacebook } from "react-icons/cg";
import { ImTwitter } from "react-icons/im";
import { FaInstagram } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <Container>
      <FooterWrapper>
        <div>
          <h3 className="get__touch">Get in touch</h3>
          <p className="address">Our Address</p>
          <p className="street__address">
            7a, Babatunde Jose street, off Ademola Adetokunbo Street Victoria
            Island, Lagos
          </p>
          <div>
            <p className="opening__hour">Opening Hours</p>
            <p className="opening__time">
              {" "}
              Mon-Fri: 8:00AM-5:00PM info@invest-trustltd.com
            </p>
            <p className="contact_number">(+234) 908 8971 301</p>
          </div>
        </div>
        <FooterLogo>
          <div>
            <img width="107px" height="107px" src={Image} alt="bannerImage" />
          </div>
          <p>
            What sets us apart is our ability to be part of our customer’s
            growth and transformation by providing them exciting investment
            offers and security on investments.
          </p>
          <div className="web__view">
            <div
              style={{
                marginTop: "1rem",
              }}
            >
              <Link to="/">
                <CgFacebook size={23} />
              </Link>
              <Link to="/">
                <ImTwitter size={23} />
              </Link>
              <Link to="/">
                {" "}
                <FaInstagram size={23} />
              </Link>
            </div>
            <p>© Copyright 2021 Invest-Trust Limited. All Rights Reserved.</p>
          </div>
        </FooterLogo>
        <BottomNav>
          <div>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/product">Our Products</Link>
            {/* <Link to="/media">Media</Link> */}
            <Link to="/contact">Contact</Link>
          </div>
        </BottomNav>
      </FooterWrapper>
      <div className="mobile__view">
        <div
          style={{
            marginTop: "1rem",
          }}
        >
          <Link to="/">
            <CgFacebook size={23} />
          </Link>
          <Link to="/">
            <ImTwitter size={23} />
          </Link>
          <Link to="/">
            {" "}
            <FaInstagram size={23} />
          </Link>
        </div>
        <p className="copyright__text">© Copyright 2021 Invest-Trust Limited.  <br />
        All Rights Reserved.</p>
      </div>
    </Container>
  );
};

export default Footer;

export const Container = styled.div`
  margin-top: -1.2rem;
  margin-bottom:-2rem;
  background-color: #1e2833;
  .mobile__view {
    display: none;
  }
  @media screen and (max-width: 991px) {
    .mobile__view {
      display: block;
    }
    .mobile__view div {
      display: flex;
      justify-content: center;
      gap: 2.5rem;
    }
    .mobile__view a {
      color: #fff;
    }
    .copyright__text {
      text-align: center;
      margin-left: 3rem;
      margin-right: 3rem;
      color: #fff;
      padding-bottom: 4rem;
    }
  }
`;

export const FooterWrapper = styled.div`
  max-width: 1440px;
  margin: auto;

  padding-left: 5rem;
  padding-right: 5rem;
  padding-top: 4rem;
  padding-bottom: 2rem;
  color: ${({ theme }) => theme.colors.text};
  display: grid;
  grid-template-columns: 25% 40% 20%;
  justify-content: space-between;
  // border: 3px solid red;

  div .get__touch {
    margin-bottom: 0rem;
    font-weight: 700;
    font-size: 24px;
  }
  div .address {
    margin-bottom: 0rem;
    color: #bcbcbc;
    font-weight: 700;
    font-size: 20px;
  }
  div .street__address {
  }

  div .opening__hour {
    margin-top: 3rem;
    color: #bcbcbc;
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 0rem;
  }
  div .opening__time {
    margin-top: 0.5rem;
  }

  @media screen and (max-width: 991px) {
    grid-template-columns: 1fr;
    div .get__touch {
      text-align: center;
    }
    div .address {
      margin-top: 1rem;
      text-align: center;
    }
    div .street__address {
      text-align: center;
    }
    div .opening__hour {
      text-align: center;
    }
    div .opening__time {
      text-align: center;
    }
    div .contact_number {
      text-align: center;
    }
  }
  @media screen and (max-width: 579px) {
    padding-left: 2rem;
    padding-right: 2rem;
    //   justify-content: center;
  }
`;
export const FooterLogo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 0rem;

  p {
    text-align: center;
    margin-bottom: 4rem;
  }

  p:nth-of-type(2) {
    margin-top: 2rem;
  }

  div a {
    color: ${({ theme }) => theme.colors.text};
    margin-right: 3rem;
  }
  .web__view div{
    display: flex;
    justify-content: center;
  }
  @media screen and (max-width: 991px) {
    div:nth-of-type(1) {
    }
    grid-row-start: 1;
    grid-row-end: 3;
    p {
      text-align: center;
      margin-bottom: 0rem;
      margin-left: 1rem;
      margin-right: 1rem;
    }
    .web__view {
      display: none;
    }
  }
  @media screen and (max-width: 579px) {
  }
`;
export const BottomNav = styled.div`
  padding-top: 1rem;
  padding-left: 4rem;
  div {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: start;
    gap: 4.3rem;
  }
  div a {
    color: ${({ theme }) => theme.colors.text};
  }
  @media screen and (max-width: 991px) {
    padding-top: 1rem;
    padding-left: 0rem;
    div {
      padding-left: 0rem;
      justify-content: center;
      align-items: center;
      gap: 2.3rem;
    }
  }
`;
